import React, { type ReactNode } from "react";
import classNames from "classnames";
import { AiOutlineRight } from "react-icons/ai";

import { Dropdown } from "./";

export interface IMenuProps {
  children?: IMenuItem[];
}
export interface IMenuItem {
  title?: string | ReactNode;
  icon?: ReactNode;
  shortcut?: ReactNode;
  onClick?: () => void;
  items?: IMenuItem[];
  component?: ReactNode;
  disabled?: boolean;
}

export const Menu: React.FC<IMenuProps> = ({ children }) => {
  return (
    <div className="flex flex-col w-full p-1 py-3 text-editor-title dark:rounded-md border-none dark:bg-vs-dark-background-lighter dark:text-vs-dark-text-lighter">
      {children
        ?.filter((a) => a)
        .map((item, index) => {
          if (!item.title && !item.component) {
            return (
              <span className="w-full h-5 flex items-center p-2" key={index}>
                <span className="w-full h-px bg:vs-light-text dark:bg-vs-dark-text"></span>
              </span>
            );
          } else if (item.component) {
            return (
              <div
                className={classNames(
                  item.disabled
                    ? "cursor-default text-gray-400 pointer-events-none"
                    : "hover:text-riders-green",
                  "w-full pl-5 pr-2 text-sm font-medium capitalize flex cursor-pointer items-center rounded-md"
                )}
                key={index}
                style={{ minWidth: 20 * 8 + 20 }}
              >
                {item.component}
              </div>
            );
          } else if (!item.items) {
            return (
              <div
                className={classNames(
                  item.disabled
                    ? "cursor-default text-gray-400 pointer-events-none"
                    : "hover:text-riders-green",
                  "w-full pl-5 pr-2 py-1 text-sm font-medium capitalize cursor-pointer flex items-center rounded-md"
                )}
                key={index}
                onClick={item.onClick}
                style={{ minWidth: item.title!.toString()!.length * 8 + 20 }}
              >
                {item.icon && <span className="mr-2">{item.icon}</span>}
                {item.title}
                <span className="grow" />
                {item.shortcut}
              </div>
            );
          } else {
            return (
              <Dropdown
                menu={<Menu>{item.items}</Menu>}
                key={index}
                type="hover"
                position="left-full -top-1"
              >
                <div
                  className="w-full pl-5 pr-2 py-1 text-sm font-medium capitalize flex items-center rounded-md cursor-pointer hover:text-riders-green"
                  onClick={item.onClick}
                  style={{ minWidth: item.title!.toString()!.length * 8 + 20 }}
                >
                  {item.icon}
                  {item.title}
                  <span className="grow" />
                  <AiOutlineRight />
                </div>
              </Dropdown>
            );
          }
        })}
    </div>
  );
};
